import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

interface LogoProps {
  collapsed: boolean;
}

export const Logo = ({ collapsed }: LogoProps) => {
  const [environmentName, setEnvironmentName] = useState("Digger");

  useEffect(() => {
    const hostname = window.location.hostname;

    if (hostname === "localhost" || hostname.includes("127.0.0.1")) {
      setEnvironmentName("Digger (Local)");
    } else if (hostname === "dev.digger.hr") {
      setEnvironmentName("Digger (Test)");
    } else if (hostname === "mvp.digger.hr") {
      setEnvironmentName("Digger (Dev)");
    } else if (hostname === "app.digger.hr") {
      setEnvironmentName("Digger");
    }
  }, []);

  return (
    <Link to="/" className="flex items-center px-4 py-6">
      {collapsed ? (
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center font-bold text-xl shadow-md">
          D
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center font-bold text-xl shadow-md">
            D
          </div>
          <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
            {environmentName}
          </span>
        </div>
      )}
    </Link>
  );
};
